module.exports = __webpack_public_path__ + "202408221624/img/home_iomic_2.f71676ea.png";